export default "__VITE_ASSET__Co0Uw2sk__"